import type { Answer } from './GameCollectionShelfPhoto'
import { assetSrc } from '../../media/media-asset.util'
import { gameCollectionShelfRowMap, getTemplate } from '../../media/template-loader'
import { CircleIconContainer } from '../CircleIconContainer'
import { NoImageIcon } from '../icons/NoImageIcon'
import { NumberBadge } from '../NumberBadge'
import { GameCollectionShelfPhotoList } from './GameCollectionShelfPhotoList'

export type ShelfRowData = {
  campaignId: string
  campaignImageUrl: string | null
  items: Answer[]
}

type Props = {
  shelfRowImageTemplate?: string
  shelfRowImageUrl?: string
  badgeBgColor?: string
  badgeTextColor?: string
  columnCount?: number
  shelfRowData: ShelfRowData
  handleShelfPhotoClick: (answer: Answer) => void
}

export function GameCollectionShelfRow(props: Props) {
  const { shelfRowImageTemplate = 'gameCollectionShelfRowDefault01', shelfRowImageUrl, badgeBgColor, badgeTextColor, columnCount, shelfRowData, handleShelfPhotoClick } = props

  const template = getTemplate(gameCollectionShelfRowMap, shelfRowImageTemplate)
  const shelfRowImage = shelfRowImageUrl ?? assetSrc(template)

  return (
    <div className="relative flex gap-6 pl-4">
      <img src={shelfRowImage} className="absolute -bottom-4 left-0 w-auto max-w-none" alt="shelf row image" />

      <div className="relative z-10 py-1">
        {shelfRowData.campaignImageUrl
          ? (
            <CircleIconContainer
              className="pointer-events-none shrink-0 grow-0 basis-16 bg-white bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: `url(${shelfRowData.campaignImageUrl})` }}
            />
          )
          : (
            <CircleIconContainer className="pointer-events-none shrink-0 grow-0 basis-16 bg-[rgba(246,246,246,1)]">
              <NoImageIcon width={26} height={26} />
            </CircleIconContainer>
          )}
        <NumberBadge badgeBgColor={badgeBgColor} badgeTextColor={badgeTextColor} className="absolute -right-2 bottom-0">{shelfRowData.items.length}</NumberBadge>
      </div>

      <div className="z-10 overflow-x-auto">
        <GameCollectionShelfPhotoList
          shelfRowData={shelfRowData}
          columnCount={columnCount}
          handleShelfPhotoClick={handleShelfPhotoClick}
        />
      </div>
    </div>
  )
}
